import {useCallback} from 'react';

import buttonActionService from '@/services/experienceScore/buttonActionService';
import uwmMessageService from '@/services/uwm/uwmMessageService';
import type {TipData} from '@/types/experienceScore';

const useTipClick = ({code, action, tipsGroupType, trackingValue, deviceSettingType, isButtonActive}: TipData) => {
    const onClick = useCallback(() => {
        if (action) {
            buttonActionService.run({action, tipsGroupType, trackingValue, deviceSettingType}, code);

            return;
        }

        if (code) uwmMessageService.sendOptimizeExperience(code);
    }, [code, action, tipsGroupType, trackingValue, deviceSettingType]);

    return action || isButtonActive ? onClick : undefined;
};

export default useTipClick;
